import React from 'react';
import {observer} from 'mobx-react';
import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {PreviousMeetingsWidgetUsLayoutPartialGameViewModel} from "../models/previous-meetings-widget.us-layout.partial-game.view-model";
import styles from "../styles/previous-meetings-widget.match-row.module.scss";
import {GameCardOdds, GameCardOddsProps} from "../../../core/components/odds/game-card-odds-row/game-card.odds";
import classNames from "classnames";
import {APP} from "../../../core/app/consts";

export class PreviousMeetingsWidgetMatchRowOddsProps extends PreviousMeetingsWidgetProps {
  item: PreviousMeetingsWidgetUsLayoutPartialGameViewModel;
}

export const PreviousMeetingsWidgetMatchRowOdds = observer(({controller, item}: PreviousMeetingsWidgetMatchRowOddsProps) => {
  const {state, device} = controller
  const {showOdds} = state;
  const {isSmallView} = device;

  const gameCardOdds: GameCardOddsProps = {
    game: item,
    showOdds,
    controller,
    gameOddsIsSmallView: isSmallView,
    className: classNames(styles.odds),
    source: APP.ANALYTICS.SOURCES.h2h,
  };

  return (<GameCardOdds {...gameCardOdds}/>
  )
});
